import { fixturesService } from '../index';

export async function findFixtures(payload) {
  try {
    return await fixturesService.find(payload);
  } catch (err) {
    return [];
  }
}

export async function getFixture(payload) {
  try {
    return await fixturesService.get(payload);
  } catch (err) {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/modules/fixture/api.js